import { actions } from './patientIndicatorName/actions'
import { getters } from './patientIndicatorName/getters'
import { state } from './patientIndicatorName/state'
import { mutations } from './patientIndicatorName/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
